import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  role: string;
  content: string;
  image?: string;
}
export function TestimonialCard({
  name,
  role,
  content,
  image
}: TestimonialCardProps) {
  return <div className="bg-gray-900 border border-gray-800 p-6 rounded-xl" data-id="element-88">
      <div className="flex gap-1 mb-4" data-id="element-89">
        {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-90" />)}
      </div>
      <p className="text-gray-300 mb-6 italic" data-id="element-91">"{content}"</p>
      <div className="flex items-center gap-3" data-id="element-92">
        <div className="w-10 h-10 rounded-full bg-gray-700 flex items-center justify-center text-white font-bold" data-id="element-93">
          {name.charAt(0)}
        </div>
        <div data-id="element-94">
          <p className="text-white font-bold text-sm" data-id="element-95">{name}</p>
          <p className="text-gray-500 text-xs" data-id="element-96">{role}</p>
        </div>
      </div>
    </div>;
}